/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty-pattern */
import { CDN_URL_IMAGES } from '@/configs';
import { ROUTE_PATH } from '@/constants/route-path';
import { Box } from '@chakra-ui/react';
// import { Section1 } from './Section1';
import { Section1 } from './AlphaSection';
import { Section2 } from './Section2';
import { Section3 } from './Section3';
import { Section4 } from './Section4';
import { BlogSection } from './BlogSection';
import s from './styles.module.scss';

const HomePageV2 = () => {
  return (
    <Box className={s.container}>
      {/* <Section1
        heading="MEGA WHALES"
        subTitle={
          <p>
            Earn, trade, and mine on the first decentralized crypto gaming
            protocol on Bitcoin.
          </p>
        }
        imgUrl={`${CDN_URL_IMAGES}/home-gamefi-01.jpg`}
        link={`${ROUTE_PATH.GAMEFI}`}
        titleLink={`Learn more`}
      /> */}
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      {/* <BlogSection /> */}
    </Box>
  );
};

export default HomePageV2;
